/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCart } from '@/containers'
import { type Dispatch, type SetStateAction } from 'react'
interface Props {
  cartLoading: boolean
  productName: string
  setIsOpenContact?: Dispatch<SetStateAction<boolean>>
}

const FooterProductDetailWarehouse = ({
  setIsOpenContact,
  productName,
}: Props) => {
  const { setSelectedProductBuyNow, setIsOpenBuyNow } = useCart()
  return (
    <div
      className={`footer-detail w-full flex flex-wrap justify-center fixed bottom-0 left-[50%] z-[999] max-w-[440px] translate-x-[-50%] bg-white shadow-top px-8 h-[80px]`}
    >
      <div className='flex justify-between w-full gap-2 pt-3'>
        <button
          className='rounded-lg border text-primary-base border-primary-base flex h-10 w-full items-center justify-center text-sm uppercase font-bold'
          onClick={() => setIsOpenContact && setIsOpenContact(true)}
        >
          GỌI LẠI CHO TÔI
        </button>
        <button
          className='rounded-lg border text-white bg-primary-base border-primary-base flex h-10 w-full items-center justify-center text-sm uppercase font-bold'
          onClick={() => {
            setSelectedProductBuyNow(productName)
            setIsOpenBuyNow(true)
          }}
        >
          MUA NGAY
        </button>
      </div>
    </div>
  )
}
export default FooterProductDetailWarehouse
